import { useEffect, useRef } from "react";

import { orderInsertion } from "../utils/api";
import { officeSlotPage, orderedSlotInsertionsOf, slotsAwaitingOrderOf } from "../utils/redline-insertion-slot";
import type { ConversationMessage } from "../utils/web-api";

export interface InsertionSlotOrderingInput {
  conversationId: string | undefined;
  turns: ConversationMessage[];
  agentIsAnswering: boolean;
  authHeader: string | null;
  reportFailure: (failure: unknown) => void;
}

const SLOT_KEY_SEPARATOR = "\u0000";

export function useInsertionSlotOrdering({ conversationId, turns, agentIsAnswering, authHeader, reportFailure }: InsertionSlotOrderingInput): void {
  const slotsKey = conversationId === undefined || agentIsAnswering ? "" : slotsAwaitingOrderOf(conversationId, turns).join(SLOT_KEY_SEPARATOR);
  const latestRef = useRef({ turns, reportFailure });
  latestRef.current = { turns, reportFailure };

  useEffect(() => {
    if (slotsKey === "" || conversationId === undefined || authHeader === null) return;
    const { turns: settledTurns, reportFailure: report } = latestRef.current;
    orderedSlotInsertionsOf({
      conversationId,
      turns: settledTurns,
      anchorBookmarks: slotsKey.split(SLOT_KEY_SEPARATOR),
      page: officeSlotPage,
      orderInsertion: (request) => orderInsertion(authHeader, request),
      reportFailure: (_cardId, failure) => report(failure),
    }).catch(report);
  }, [slotsKey, conversationId, authHeader]);
}
